import AbstractApiRepository from '../../../base/api/AbstractApiRepository';

export class UserApiRepository extends AbstractApiRepository {
  getCurrentUser = () => {
    return this.apiClient.get<any>({
      url: `/users`,
    });
  };
}
